import styled from 'styled-components';

// TODO
export const FluidContainer = styled.section`
  width: 100%;
  position: relative;
`;
